export class GoogleDistanceService {
  public static async getDistanceBetween(origin: string, destination: string): Promise<number> {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const directionsService = new google.maps.DirectionsService();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const directionsRenderer = new google.maps.DirectionsRenderer();
      const route = {
        origin,
        destination,
        travelMode: 'DRIVING'
      }

      directionsService.route(route,
        function (response: any, status: string) { // anonymous function to capture directions
          if (status !== 'OK') {
            reject(new Error('Couldnt calculate distance'));
          } else {
            directionsRenderer.setDirections(response); // Add route to the map
            const directionsData = response.routes[0].legs[0]; // Get data about the mapped route
            if (!directionsData) {
              reject(new Error('Couldnt calculate distance'));
            } else {
              resolve(directionsData.duration.value / 3600)
              // document.getElementById('msg').innerHTML += " Driving distance is " + directionsData.distance.text + " (" + directionsData.duration.text + ").";
            }
          }
        });
    });
  }
}
